import React from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import Skills from "../../containers/skills/Skills";
import Footer from "../../components/footer/Footer";
import "./HomeComponent.css";

function Home(props) {
  return (
    <div className="home-container">
      <Header theme={props.theme} setTheme={props.setTheme} />
      <Greeting theme={props.theme} />
      <div className="section-gap">
        <Skills theme={props.theme} />
      </div>
      <Footer theme={props.theme} />
    </div>
  );
}

export default Home;
